// extracted by mini-css-extract-plugin
module.exports = {"modal":"style_modal__1prhQ","cont":"style_cont__32xqX","form":"style_form__3PUPC","submitBtn":"style_submitBtn__2nBvZ"};